export default {
      id: "ETH-usage",
      viewBox: "0 0 141.2 226.8",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#ETH",
      toString: function () {
        return this.url;
      }
    }